/**
 * This script manages the behavior of side modals to ensure only one modal is open at any given time.
 * 
 * Expected behaviors:
 * - Only one modal can be open at a time.
 * - The main modal (promotion modal) is open by default.
 * - The secondary modal (sub modal) is closed by default.
 * 
 * Functionality:
 * - When a close button or toggle button is clicked, the currently expanded modal will be closed.
 */

function sideModalToggle() {
    // Cache jQuery selectors for future use.
    const MODAL_CONTAINER = $('.side-modal-container'),
        TOGGLE_BUTTONS = MODAL_CONTAINER.find('button[data-toggle]'),  // Toggle buttons that open/close modals.
        MODALS = MODAL_CONTAINER.find('.content'), // All content modals.
        EXPANDED_MODAL = MODAL_CONTAINER.find('.expanded'),  // Currently expanded modal.
        TRIGGER_MODAL = $('.side-modal-container').data('delay-container'),
        TRIGGERED_BUTTON = $(`button[data-toggle="${TRIGGER_MODAL}"]`),
        TRIGGER_DELAY_MODAL = parseInt($('.side-modal-container').data('delay-trigger'));

    $(function() {
        // Ensure the modal container is displayed.
        MODAL_CONTAINER.css({'display': 'block'});

        /**
         * Closes all modals by removing the 'expanded' class from all content elements.
         */
        function closeAllModals() {
            if (MODALS.length) {
                MODALS.removeClass('expanded');
            }
        }

        /**
         * Closes the currently expanded modal by removing the 'expanded' class from its content element.
         */
        function closeExpandedModal() {
            if (EXPANDED_MODAL.length) {
                EXPANDED_MODAL.removeClass('expanded');
            }
        }

        /**
         * Resets the aria-expanded attribute to false for all toggle buttons within the component.
         */
        function resetAriaExpanded() {
            if (TOGGLE_BUTTONS.length) {
                TOGGLE_BUTTONS.attr('aria-expanded', 'false');
            }
        }

        // Attach event listeners using delegation for better performance on dynamic elements.
        MODAL_CONTAINER.on('click', '.close-button', function() {
            resetAriaExpanded();
            closeAllModals();
        });

        MODAL_CONTAINER.on('click', 'button[data-toggle]', function() {
            const TARGET_MODAL = $(this).next('.content');

            // Check if the target modal is already expanded.
            if (TARGET_MODAL.hasClass('expanded')) {
                // Only attempt to close the target modal if it's already expanded.
                closeExpandedModal();
            } else {
                // Close all modals if the target modal is collapsed.
                closeAllModals();
            }

            resetAriaExpanded();
        });

         // Check if a delay is set for triggering the modal and for the triggered button
         if (TRIGGER_DELAY_MODAL > 0 && TRIGGERED_BUTTON.length) {
            setTimeout(() => {          
                // Instead of .trigger('click'), we add the necessary attributes directly to avoid timing issues with iframes.
                TRIGGERED_BUTTON.attr('aria-expanded','true');
                TRIGGERED_BUTTON.next('.content').addClass('expanded');
                
            }, TRIGGER_DELAY_MODAL);
            
        }
     });    
}

// Expose the sideModalToggle function to the global window object to make it accessible throughout the application.
window.sideModalToggle = sideModalToggle;
